// convert two 24 hour times to a time range like "6 to 9 p.m." or "9 a.m. to 12 p.m."
export default function formatTimeRange(
  startTime: string,
  endTime: string
): string {
  // pad startTime to 4 characters
  const startTimeHours = parseInt(
    startTime.padStart(4, `0`).substring(0, 2),
    10
  )
  const startTimeMinutes = startTime.padStart(4, `0`).substring(2, 4)
  const endTimeHours = parseInt(endTime.padStart(4, `0`).substring(0, 2), 10)
  const endTimeMinutes = endTime.padStart(4, `0`).substring(2, 4)
  let startTimeAmPm = startTimeHours < 12 ? `a.m.` : `p.m.`
  const endTimeAmPm = endTimeHours < 12 ? `a.m.` : `p.m.`
  if (startTimeAmPm === endTimeAmPm) startTimeAmPm = ``
  const startTimeHour = startTimeHours % 12 || 12
  const endTimeHour = endTimeHours % 12 || 12
  const startTimeString = `${startTimeHour}:${startTimeMinutes} ${startTimeAmPm}`
  const endTimeString = `${endTimeHour}:${endTimeMinutes} ${endTimeAmPm}`
  return `${startTimeString} to ${endTimeString}`
}
